import { IS_VIVUS, IS_VIVUS_ONLINE } from 'utils/constants';
import { ROUTES } from 'utils/constants/constants_routes';
import { useLocation } from 'react-router-dom';

// Hooks + constants + config -> useCrossDomainLoginRedirect + AppConfig + Constants

export const useProduct = () => {
  const { pathname } = useLocation();
  let valueRelatedToProduct;

  switch (pathname) {
    // useCrossDomainLoginRedirect - redirection
    case ROUTES.FIRST_LOAN:
    case ROUTES.FIRST_LOAN_MOBILE:
      // Show/Hide warning
      valueRelatedToProduct = IS_VIVUS_ONLINE;
      break;
    case ROUTES.AFFILIATE_FIRST_LOAN_APPLICATION:
      // FAQ items
      valueRelatedToProduct = IS_VIVUS ? 'items_vivus' : 'items_vivusonline';
  }

  return { valueRelatedToProduct };
};
